import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthService } from '@auth/auth-service';

import { Observable } from 'rxjs';

/**
 * Adds impersonation context headers to outbound API requests when the user
 * is currently acting as another user. The backend reads
 * `X-Impersonate-User-Id` to know which userId to act as and
 * `X-Original-User` to authorize the impersonation
 * against and to write the audit log.
 */
@Injectable()
export class ImpersonationInterceptor implements HttpInterceptor {
  private readonly authService = inject(AuthService);

  intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    const context = this.authService.getUserContext();

    if (!context.impersonatedUserId) {
      return next.handle(req);
    }

    const modifiedReq = req.clone({
      headers: req.headers
        .set('X-Impersonate-User-Id', context.impersonatedUserId)
        .set('X-Original-User', context.originalUser ?? ''),
    });
    return next.handle(modifiedReq);
  }
}
